var _rect, _rect2, _rect3, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrescriptionDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 680,
    viewBox: "0 0 492 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.444336,
    width: 491.111,
    height: 680,
    rx: 8,
    fill: "#303642"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.444,
    y: 67,
    width: 216,
    height: 50,
    rx: 6,
    fill: "#5E6472"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.4443,
    y: 163,
    width: 377,
    height: 450,
    rx: 6,
    fill: "#5E6472"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.444 438.188L213.604 383.42L242.675 412.415L277.322 368.117L332.676 438.188H159.444Z",
    fill: "#303642"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213.457,
    cy: 352.058,
    r: 16.058,
    fill: "#303642"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionDefault);
export default __webpack_public_path__ + "static/media/prescription_default.0704fb91d3c1220c98a4405452832505.svg";
export { ForwardRef as ReactComponent };